import React, { Component } from 'react'
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import './Table.css'
import { post, port, getImg } from '../../service/index'
import { connect } from 'react-redux'

const columns = [
    {
        id: 'list',
        minWidth: 200,
        Header: <p style={{ fontSize: 18, color: '#fff' }} >รายชื่อ</p>,
        headerStyle: { border: 'none', backgroundColor: 'rgb(106, 213, 215)', height: 48, display: 'flex', justifyContent: 'center', alignItems: 'center' },
        accessor: t => t.list,
        style: { padding: 0, border: 'none', height: 48 },
        Cell: props => <ProfileItem {...props.value} index={props.index} />
        // Cell: props => console.log(props)
    }, {
        Header: <p style={{ fontSize: 18, color: 'rgb(115, 213, 216)' }} >เบอร์โทร</p>,
        accessor: 'phone',
        style: { padding: 0, border: 'none' },
        headerClassName: 'normal-header-table',
        Cell: props =>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', background: props.index % 2 == 0 ? '#fff' : 'rgb(249, 249, 249)', fontSize: 16 }} ><span>{props.value && props.value !== 'null' ? props.value : ''}</span></div> // Custom cell components!
    }, {
        Header: <p style={{ fontSize: 18, color: 'rgb(115, 213, 216)' }} >เข้า</p>,
        accessor: 'enter',
        style: { padding: 0, border: 'none' },
        headerClassName: 'normal-header-table',
        Cell: props => {
            const { value } = props
            const HH = value ? String(Number(value.split('T')[1].split('.')[0].slice(0, 2)) + 7) : '00'
            const renderHH = HH.length === 2 ? HH : "0" + HH
            const mm = value ? value.split('T')[1].split('.')[0].slice(3, 5) : '00'
            const renderTime = value ? renderHH + ':' + mm + ' น.' : null
            return (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', background: props.index % 2 == 0 ? '#fff' : 'rgb(249, 249, 249)', fontSize: 16 }} ><span>{renderTime}</span></div> // Custom cell components!
            )
        }
    }, {
        Header: <p style={{ fontSize: 18, color: 'rgb(115, 213, 216)' }} >ออก</p>,
        accessor: 'exit',
        style: { padding: 0, border: 'none' },
        headerClassName: 'normal-header-table',
        Cell: props => {
            const { value } = props
            const HH = value ? String(Number(value.split('T')[1].split('.')[0].slice(0, 2)) + 7) : '00'
            const renderHH = HH.length === 2 ? HH : "0" + HH
            const mm = value ? value.split('T')[1].split('.')[0].slice(3, 5) : '00'
            const renderTime = value ? renderHH + ':' + mm + ' น.' : null
            return (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', background: props.index % 2 == 0 ? '#fff' : 'rgb(249, 249, 249)', fontSize: 16 }} ><span>{renderTime}</span></div> // Custom cell components!
            )
        }

    }
]

class AttendessMeetingTable extends Component {

    constructor(props) {
        super(props)

        this.state = {
            currentPage: 0
        }
    }


    render() {
        const { count_person } = this.props
        return (
            <div style={{ width: '100%', padding: 8, marginTop: 20, marginRight: 20, marginBottom: 20 }} className='card' >
                <span style={{ display: 'flex', flexDirection: 'row', marginBottom: 10 }} >
                    <p style={{ fontSize: 25, marginRight: 10, color: 'rgb(106, 213, 215' }} > ผู้เข้าร่วมประชุม </p>
                    <p style={{ fontSize: 25 }} > ( {count_person} คน) </p>
                </span>
                <ReactTable
                    data={this.props.data}
                    columns={columns}
                    showPageSizeOptions={false}
                    defaultPageSize={8}
                    style={{ width: '100%' }}
                    sortable={false}
                    resizable={false}
                    onPageChange={(e) => this.setState(prevState => ({ data: prevState.data.map(el => ({ ...el, list: { ...el.list, currentPage: e } })) }))}
                />
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    login: state.login
})

class ProfileItem extends Component {
    constructor(props) {
        super(props)

        this.state = {
            avatar: null
        }
    }

    componentDidMount = () => {
        this.fetchImage()
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if (this.props.currentPage !== nextProps.currentPage) {
            this.fetchImage()
        }
        return true
    }

    fetchImage = async () => {
        try {
            const avatar = await getImg('/image/' + this.props.picture, this.props.token)
            this.setState({ avatar })
        } catch (err) {
            console.log(err)
        }
    }


    render() {
        const { name, picture, position, index } = this.props
        const { avatar } = this.state
        return (
            <div className='meeting-profile' style={{ backgroundColor: index % 2 == 0 ? 'rgb(211, 242, 242)' : 'rgb(207, 238, 238)', display: 'flex', height: '100%' }} >
                <img src={avatar} className='meeting-profile-image' />
                <span>
                    <p style={{ fontSize: 18, lineHeight: 1 }} >{name}</p>
                    <p style={{ fontSize: 14 }} >{position && position !== 'null' ? position : null}</p>
                </span>
            </div>
        )
    }
}


export default connect(mapStateToProps)(AttendessMeetingTable)

const mockData = [
    {
        list: {
            name: 'Tanner Linsley',
            picture: "https://cdn3.iconfinder.com/data/icons/avatars-15/64/_Ninja-2-256.png",
            position: 'ตำแหน่งงาน'
        },
        phone: '080-1234567',
        enter: '14.00 น.',
        exit: '16.00 น.',
    },
    {
        list: {
            name: 'Tanner Linsley',
            picture: "https://cdn3.iconfinder.com/data/icons/avatars-15/64/_Ninja-2-256.png",
            position: 'ตำแหน่งงาน'
        },
        phone: '080-1234567',
        enter: '14.00 น.',
        exit: '16.00 น.',
    },
    {
        list: {
            name: 'Tanner Linsley',
            picture: "https://cdn3.iconfinder.com/data/icons/avatars-15/64/_Ninja-2-256.png",
            position: 'ตำแหน่งงาน'
        },
        phone: '080-1234567',
        enter: '14.00 น.',
        exit: '16.00 น.',
    },
    {
        list: {
            name: 'Tanner Linsley',
            picture: "https://cdn3.iconfinder.com/data/icons/avatars-15/64/_Ninja-2-256.png",
            position: 'ตำแหน่งงาน'
        },
        phone: '080-1234567',
        enter: '14.00 น.',
        exit: '16.00 น.',
    },
    {
        list: {
            name: 'Tanner Linsley',
            picture: "https://cdn3.iconfinder.com/data/icons/avatars-15/64/_Ninja-2-256.png",
            position: 'ตำแหน่งงาน'
        },
        phone: '080-1234567',
        enter: '14.00 น.',
        exit: '16.00 น.',
    },
    {
        list: {
            name: 'Tanner Linsley',
            picture: "https://cdn3.iconfinder.com/data/icons/avatars-15/64/_Ninja-2-256.png",
            position: 'ตำแหน่งงาน'
        },
        phone: '080-1234567',
        enter: '14.00 น.',
        exit: '16.00 น.',
    },
    {
        list: {
            name: 'Tanner Linsley',
            picture: "https://cdn3.iconfinder.com/data/icons/avatars-15/64/_Ninja-2-256.png",
            position: 'ตำแหน่งงาน'
        },
        phone: '080-1234567',
        enter: '14.00 น.',
        exit: '16.00 น.',
    },
    {
        list: {
            name: 'Tanner Linsley',
            picture: "https://cdn3.iconfinder.com/data/icons/avatars-15/64/_Ninja-2-256.png",
            position: 'ตำแหน่งงาน'
        },
        phone: '080-1234567',
        enter: '14.00 น.',
        exit: '16.00 น.',
    },
    {
        list: {
            name: 'Tanner Linsley',
            picture: "https://cdn3.iconfinder.com/data/icons/avatars-15/64/_Ninja-2-256.png",
            position: 'ตำแหน่งงาน'
        },
        phone: '080-1234567',
        enter: '14.00 น.',
        exit: '16.00 น.',
    },
    {
        list: {
            name: 'Tanner Linsley',
            picture: "https://cdn3.iconfinder.com/data/icons/avatars-15/64/_Ninja-2-256.png",
            position: 'ตำแหน่งงาน'
        },
        phone: '080-1234567',
        enter: '14.00 น.',
        exit: '16.00 น.',
    },
    {
        list: {
            name: 'Tanner Linsley',
            picture: "https://cdn3.iconfinder.com/data/icons/avatars-15/64/_Ninja-2-256.png",
            position: 'ตำแหน่งงาน'
        },
        phone: '080-1234567',
        enter: '14.00 น.',
        exit: '16.00 น.',
    },
    {
        list: {
            name: 'Tanner Linsley',
            picture: "https://cdn3.iconfinder.com/data/icons/avatars-15/64/_Ninja-2-256.png",
            position: 'ตำแหน่งงาน'
        },
        phone: '080-1234567',
        enter: '14.00 น.',
        exit: '16.00 น.',
    },
]


// WEBPACK FOOTER //
// ./src/components/Table/AttendessMeetingTable.js